import { styled } from '@mui/material/styles';
import { Accordion } from '@mui/material';

const StyledTipsList = styled('div')`
  width: 100%;
  max-width: 100%;
`;

const StyledAccordion = styled(Accordion)`
  margin-bottom: 16px !important;
  border-radius: 12px !important;
  border: 1px solid #1e164e29;
  padding: 16px !important;
  box-shadow: none !important;
  &:last-child {
    margin-bottom: 0 !important;
  }
`;

export { StyledTipsList, StyledAccordion };
